import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

// Device illustrations for the mobile energy hub. Drawn as line art rather than
// solid MUI glyphs so each one reads as the actual piece of hardware (panel array,
// grid pole, battery cabinet, house) — customers recognise their own system far
// faster than they parse abstract symbols. Inline vectors: a few hundred bytes each,
// they take their colour from `sx`, and there is no asset to license or maintain.

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export function SolarArrayIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g {...stroke}>
        <path d="M8 4.5h12.5l-4 9H4l4-9Z" />
        <path d="M6 9h12.2" />
        <path d="M12.2 4.5 8.6 13.5" />
        <path d="M16.4 4.5 12.8 13.5" />
        <path d="M12 13.5V18" />
        <path d="M9 19.5h6" />
      </g>
    </SvgIcon>
  );
}

export function GridPoleIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g {...stroke}>
        <path d="M12 3.5V20.5" />
        <path d="M5 7.5h14" />
        <path d="M7 11.5h10" />
        <path d="M8.5 20.5h7" />
        <path d="M8 7.5V6" />
        <path d="M16 7.5V6" />
        <path d="M9.5 11.5V10" />
        <path d="M14.5 11.5V10" />
      </g>
    </SvgIcon>
  );
}

export function BatteryCabinetIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g {...stroke}>
        <path d="M10 3.5h4" />
        <rect x="6" y="5.5" width="12" height="15" rx="2" />
        <path d="M6 10.5h12" />
        <path d="M6 15.5h12" />
      </g>
    </SvgIcon>
  );
}

export function HouseIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g {...stroke}>
        <path d="M3.5 11.2 12 4.2l8.5 7" />
        <path d="M5.6 9.7V20h12.8V9.7" />
        <path d="M10 20v-5.2h4V20" />
      </g>
    </SvgIcon>
  );
}

// The conventional inverter symbol: DC in on one side, AC out on the other.
export function InverterIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g {...stroke}>
        <rect x="3.5" y="5" width="17" height="14" rx="2.5" />
        <path d="M5.6 18.4 18.4 5.6" />
        <path d="M6.6 8.4h4" />
        <path d="M6.6 11h4" />
        <path d="M13 15.8c.7-1.9 1.4-1.9 2.1 0s1.4 1.9 2.1 0" />
      </g>
    </SvgIcon>
  );
}
